import ArammConfig from "./ArammConfig";

export default ArammConfig;
